import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_switch = _resolveComponent("vxe-switch");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_vxe_switch, _mergeProps(_ctx.$attrs, {
    "model-value": $props.value,
    disabled: _ctx.disabled,
    readonly: _ctx.readonly,
    size: _ctx.size,
    "open-label": $props.openLabel,
    "close-label": $props.closeLabel,
    "open-value": $props.openValue,
    "close-value": $props.closeValue,
    "open-icon": $props.openIcon,
    "close-icon": $props.closeIcon,
    "open-active-icon": $props.openActiveIcon,
    "close-active-icon": $props.closeActiveIcon,
    onChange: $setup.handleChanged
  }), null, 16, ["model-value", "disabled", "readonly", "size", "open-label", "close-label", "open-value", "close-value", "open-icon", "close-icon", "open-active-icon", "close-active-icon", "onChange"]), _renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString($props.title), 1)])], 64);
}